import { render, staticRenderFns } from "./SuccessStoriesCustomer.vue?vue&type=template&id=16833226"
import script from "./SuccessStoriesCustomer.vue?vue&type=script&lang=js"
export * from "./SuccessStoriesCustomer.vue?vue&type=script&lang=js"
import style0 from "./SuccessStoriesCustomer.vue?vue&type=style&index=0&id=16833226&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports